import { useMemo } from 'react';
import { ArrayModel, createObjectMap } from 'utils';

export const useMap = <M extends any[]>(source: M, key: keyof ArrayModel<M>) => {
  return useMemo(() => {
    return createObjectMap(source, key);
  }, [source, key]);
};
